import React from "react";
import { View, StyleSheet, Platform, Dimensions } from "react-native";

import appStyles from "../../../appStyles";
import TimePickerQuickEntry from "./TimePickerQuickEntry";
import TimePickerManualEntry from "./TimePickerManualEntry";
import TimePickerSwipeHeader from "./TimePickerSwipeHeader";
import { isWeb } from '../../../../helpers/utils';

const { height: HEIGHT } = Dimensions.get("window");

export default function TimePickerSwipe(props) {
  const {
    timeslot,
    minutesInterval,
    isManualEntry,
    onTimeChanged = () => {},
    showTutorials = false,
    disableStartTime = false,
    disableEndTime = false,
  } = props;

  const { startTime, endTime } = timeslot;
  const dialogOffset = isWeb ? 400 : 200;

  return (
    <View
      style={[
        styles.container,
        isManualEntry
          ? styles.manual
          : {
              height: 570,
              maxHeight: HEIGHT - dialogOffset,
            },
      ]}
    >
      {/* Header */}
      <TimePickerSwipeHeader timeslot={timeslot} />

      {!isManualEntry ? (
        <View style={styles.swipeContainer}>
          {/* Start */}
          <TimePickerQuickEntry
            isStartTime
            startTime={startTime}
            endTime={endTime}
            timeslotDate={timeslot.startDate}
            onTimeChanged={onTimeChanged}
            maxHours={props.maxHours}
            showLabels={props.showLabels}
            use24hFormat={props.use24hFormat}
            minutesInterval={minutesInterval}
            showTutorials={showTutorials}
            disablePills={disableStartTime}
            dialogOffset={dialogOffset}
          />

          {/* End */}
          <TimePickerQuickEntry
            startTime={startTime}
            endTime={endTime}
            timeslotDate={timeslot.startDate}
            onTimeChanged={onTimeChanged}
            maxHours={props.maxHours}
            showLabels={props.showLabels}
            use24hFormat={props.use24hFormat}
            minutesInterval={minutesInterval}
            showTutorials={showTutorials}
            disablePills={disableEndTime}
            dialogOffset={dialogOffset}
          />
        </View>
      ) : (
        <TimePickerManualEntry
          startTime={startTime}
          endTime={endTime}
          timeslotDate={timeslot.startDate}
          onTimeChanged={onTimeChanged}
          use24hFormat={props.use24hFormat}
          minutesInterval={minutesInterval}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    ...appStyles.maxWidth,
  },
  manual: {
    height: 210,
  },
  header: {
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
  swipeContainer: {
    flex: 1,
    borderTopWidth: 1,
    borderTopColor: "#F5F5F5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  durationContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  time: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "#2D3142",
    marginRight: 5,
  },
  duration: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "#2D3142",
  },
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#2D3142",
    paddingTop: 3,
  },
  selectedDate: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: "#2D3142",
  },
  warning: {
    backgroundColor: "#F6EC91",
  },
  warningText: {
    color: "#DD5F43",
  },
});
